import React, { FC } from "react";
import { createPortal } from "react-dom";
import { Backdrop, Button, CircularProgress } from "@mui/material";
import styles from "./ConfirmLogoutModal.module.scss";

interface ConfirmLogoutModalProps {
  onClose: () => void;
  onSubmit?: () => void;
  isSubmitting?: boolean;
}

const ConfirmLogoutModal: FC<ConfirmLogoutModalProps> = ({
  onClose,
  onSubmit,
  isSubmitting,
}) => {
  const handleConfirm = () => {
    onSubmit?.();
  };

  return createPortal(
    <div className="create-promotion-modal">
      <Backdrop open={true}>
        <div className={styles["modalContainer"]}>
          <h4 className={styles["modalContainer__title"]}>Logout</h4>

          <div className={styles["modalContainer__inputWrapper"]}>
            Are you sure you want to logout?
          </div>

          <div className={styles["modalContainer__buttonGroup"]}>
            <Button
              onClick={onClose}
              className={`${styles["modalContainer__buttonGroup__cancelButton"]} create-promo-cancel-button`}
              variant="outlined"
              disabled={isSubmitting}
            >
              Cancel
            </Button>

            <Button
              onClick={handleConfirm}
              className={`${styles["modalContainer__buttonGroup__submitButton"]} create-promo-submit-button`}
              variant="contained"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <CircularProgress size={22} color="inherit" />
              ) : (
                "Logout"
              )}
            </Button>
          </div>
        </div>
      </Backdrop>
    </div>,
    document.body,
  );
};

export default ConfirmLogoutModal;
